
// src/pages/NotFound.js
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Container className="text-center py-5">
            <div className="mb-4">
                <span className="display-1 fw-bold text-primary">404</span>
            </div>
            <h1 className="mb-3">Stránka nenalezena</h1>
            <p className="text-muted mb-4 fs-5">
                Omlouváme se, ale stránka, kterou hledáte, neexistuje nebo byla přesunuta.
            </p>
            <div className="d-grid gap-3 col-lg-3 col-md-5 col-sm-8 mx-auto">
                <Button as={Link} to="/dashboard" variant="primary" size="lg">
                    <i className="fas fa-home me-2"></i> Zpět na dashboard
                </Button>
                <Button as="a" href="mailto:support@wp-monitor.com" variant="outline-primary">
                    <i className="fas fa-envelope me-2"></i> Kontaktovat podporu
                </Button>
            </div>
        </Container>
    );
};

export default NotFound;